import api from './';

let startPath = process.env.ENVIRONMENT === "local" ? "prescriptions" : "Prescription"

export default {
  download: (id) => api.get(`${startPath}/${id}/download`).blob(),
};
